module.exports = __webpack_public_path__ + "img/github.1987e827.svg";